import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeliveryLocationMap from '../../components/DeliveryLocationMap';
import SelectedEmplacementDeliveryInput from '../../components/SelectedEmplacementDeliveryInput';
import VehicleLayout from '../../components/VehicleLayout';
import { useAxios } from '../../utils/hook/useAxios';

function LocationDelivery() {
  const axios = useAxios();
  const [voitures, setVoitures] = useState([]);
  const userData = JSON.parse(window.localStorage.getItem('me'));
  const { vehiculeId, AnnonceId } = useParams();

  const [Emplacements, setEmplacements] = useState([]);
  const [EmplacementVehicule, setEmplacementVehicule] = useState(null);
  const [DeliveryCost, setDeliveryCost] = useState(0);
  const [PriseEnChargeMethod, setPriseEnChargeMethod] = useState('0');
  const [MoreInfos, setMoreInfos] = useState('');
  const [locationCenter, setLocationCenter] = useState([0, 0]);
  const [locationPlaceName, setLocationPaceName] = useState('');
  const [resetInput, setResetInput] = useState(true);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const emplaresp = await axios.get('/deliverylocation');
        if (emplaresp.data) {
          setEmplacements(emplaresp.data);
        }
        const response = await axios.get('/deliverylocation/getannoncebyid/' + AnnonceId);
        if (response.data) {
          setEmplacementVehicule(response.data[0]);
          setDeliveryCost(response.data[0].deliveryCosts);
          setPriseEnChargeMethod(response.data[0].PriseEnChargeMethod);
          setMoreInfos(response.data[0].MoreInfo);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  const [showLeft, setShowLeft] = useState(true);
  const [showRight, setShowRight] = useState(true);

  function handleModifierLieuxPriseEnCharge() {
    let fetchReviews = async () => {
      try {
        const response = await axios.put('/deliverylocation/' + AnnonceId, {
          deliveryCosts: DeliveryCost,
          PriseEnChargeMethod: PriseEnChargeMethod,
          MoreInfo: MoreInfos,
        });

        if (response.data) {
          toast.success('Lieu de prise en charge  modifié  pour votre annonce');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }

  function handleModifierEmplacement() {
    let fetchReviews = async () => {
      try {
        const response = await axios.put('/deliverylocation/' + AnnonceId, {
          addressEmplacementDelivery: locationPlaceName,
          locationCoords: locationCenter[1].toString() + ',' + locationCenter[0].toString(),
        });

        if (response.data) {
          toast.success("Lieu de l'emplacement et livraison  modifié  pour votre annonce");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }

  const handleLocationSelection = (locationAddress) => {
    setLocationCenter(locationAddress.center);
    setLocationPaceName(locationAddress.place_name);
  };

  return (
    <VehicleLayout vehicleId={vehiculeId} pageTitle="Emplacements">
      <ToastContainer />
      <div className="row">
        <div className="col-12 col-md-8" style={{ zIndex: 2 }}>
          <DeliveryLocationMap
            centers={Emplacements}
            centercoords={[49.604236, 6.133404]}
          ></DeliveryLocationMap>
        </div>
        {showRight && (
          <div className="col-md-3 mb-3" style={{ zIndex: 1 }}>
            <h3>Emplacements et livraison</h3>
            <p>
              Augmentez vos revenus en offrant la livraison. Les frais de livraison incluent la
              prise en charge et le retour. Vous recevez 90 % de ces frais.
            </p>
            <div class="offcanvas-body">
              <p className="">
                <strong>Domicile</strong>
              </p>
              <hr />
              <div className="d-flex justify-content-between mb-3">
                <h3>
                  <ion-icon name="home-outline"></ion-icon>
                </h3>
                <div>
                  <p>{EmplacementVehicule?.addressEmplacementDelivery}</p>
                  <small className="text-muted">
                    La prise en charge et le retour de votre véhicule
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn btn-secondary mb-2 w-100"
                data-bs-toggle="collapse"
                data-bs-target="#collapseModifier"
                aria-expanded="false"
                aria-controls="collapseModifier"
              >
                <i class="bi bi-arrow-down-square"></i> Modifier
              </button>

              <div class="collapse" id="collapseModifier">
                <div class="card card-body">
                  <h4>Domicile</h4>
                  <p className="mb-3">
                    Pour assurer la confidentialité de vos données, nous ne divulguons l’emplacement
                    de votre voiture aux invités qu’une fois que vous avez confirmé leur voyage.
                  </p>
                  <SelectedEmplacementDeliveryInput
                    handleSelectLocation={handleLocationSelection}
                    resetInput={resetInput}
                  ></SelectedEmplacementDeliveryInput>

                  <button
                    className="btn btn-tertiary mt-2"
                    type="button"
                    onClick={handleModifierEmplacement}
                  >
                    Enregistrer
                  </button>
                </div>
              </div>
              <hr />
              <p>
                <strong>Lieu de livraison</strong>
              </p>
              <div className="d-flex justify-content-between mb-3">
                <h3>
                  <ion-icon name="train-outline"></ion-icon>
                </h3>
                <div>
                  <p>{EmplacementVehicule?.deliveryAddressName}</p>
                  <small className="text-muted">Sans frais, rencontrez les invités</small>
                </div>

                <button
                  type="button"
                  className="btn btn-tertiary"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseLieuxLivraison"
                  aria-expanded="false"
                  aria-controls="collapseLieuxLivraison"
                >
                  Modifier
                </button>
              </div>
              <div class="collapse" id="collapseLieuxLivraison">
                <div class="card card-body">
                  <h4>Modifier le lieu de livraison</h4>
                  <p className="mb-3">
                    <strong>{EmplacementVehicule?.deliveryAddressName}</strong>
                  </p>
                  <label for="exampleFormControlInput1" class="form-label">
                    Frais de livraison
                  </label>
                  <div class="mb-3 input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="5"
                      value={DeliveryCost}
                      onChange={(e) => setDeliveryCost(e.target.value)}
                    />
                    <span class="input-group-text bg-primary text-white border-primary">€</span>
                  </div>
                  <label for="exampleFormControlInput1" class="form-label">
                    Méthode de prise en charge
                  </label>
                  <div class="mb-3 input-group">
                    <select
                      class="form-select"
                      size="3"
                      aria-label="Méthode de prise en charge"
                      value={PriseEnChargeMethod}
                      onChange={(e) => setPriseEnChargeMethod(e.target.value)}
                    >
                      <option value="0">Rencontrez les invités</option>

                      <option value="1">Boite à clé sécurisée</option>
                      <option value="2">Déverouillage à distance</option>
                      <option value="3">Autre</option>
                    </select>
                  </div>

                  <label for="exampleFormControlInput1" class="form-label">
                    Infos supplémentaire
                  </label>
                  <div class="mb-3 input-group">
                    <textarea
                      type="text"
                      class="form-control"
                      id="exampleFormControlInput1"
                      placeholder="Donnez plus d'infos à vos invités"
                      rows={3}
                      value={MoreInfos}
                      onChange={(e) => setMoreInfos(e.target.value)}
                    />
                  </div>

                  <button
                    className="btn btn-tertiary mb-2"
                    type="button"
                    onClick={handleModifierLieuxPriseEnCharge}
                  >
                    Enregistrer
                  </button>
                  <button className="btn btn-danger" type="button">
                    Supprimer ce lieu
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </VehicleLayout>
  );
}

export default LocationDelivery;
